module.exports = __webpack_public_path__ + "img/avartar.8c3db21f.png";